(function ($) {
 	$.fn.capitechAbsenceForm = function(options) {
		var ctAbsenceFormModel;
		var $ctAbsenceFormElm = $(this);
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			// Set up view model
			ctAbsenceFormModel = new absenceFormModel();
			ko.applyBindings(ctAbsenceFormModel, $ctAbsenceFormElm[0]);
			
			// Attach time mask to input
			resetAbsenceForm();
			
			getAbsenceCodes();
		}
		
		function getAbsenceCodes() {
			var success = function success(data, textStatus, jqXHR) {
				loaderIndicator(false);
				
				if (data.success == true) {
					ctAbsenceFormModel.addAbsenceCodes(data.content);
				} else {
					sweetAlert(getResource('message.sentFailedTitle', 'Error'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.getAbsenceCodes_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME));
		}
		
		function createAbsenceRequest() {
			var data = ko.toJS(ctAbsenceFormModel);
			
			var success = function success(data, textStatus, jqXHR) {
				loaderIndicator(false);
				
				if (data.success == true) {
					sweetAlert(getResource('absenceForm.sentTitle'), getResource('absenceForm.sentText'), "success");
					try {
						
						if (typeof ctAbsenceRequestsModel === 'object') {
							ctAbsenceRequestsModel.absenceRequests.unshiftFromModel({
								'id': data.content[0],
								'absenceCode': ctAbsenceFormModel.absenceCode(),
								'fromDate': ctAbsenceFormModel.fromDate(),
								'fromTime': ctAbsenceFormModel.fromTime(),
								'toDate': ctAbsenceFormModel.toDate(),
								'toTime': ctAbsenceFormModel.toTime(),
								'text': ctAbsenceFormModel.text(),
								'absenceRequestStatus': 'Created'
							});
						}
						// Reset model
						resetAbsenceForm();
					} catch (err) {
					}
					
				} else {
					sweetAlert(getResource('message.sentFailedTitle', 'Error'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			
			if (data.isShortTermAbsence) {
				data.toDate = data.fromDate;
				ctAbsenceFormModel.toDate(ctAbsenceFormModel.fromDate());
			} else {
				data.fromTime = null;
				data.toTime = null;
			}
			
			_api.createAbsenceRequest_POST(
				success,
				error,
				getCookie(ACCESSTOKEN_COOKIE_NAME),
				data.absenceCode,
				data.isShortTermAbsence,
				data.fromDate,
				data.fromTime,
				data.toDate,
				data.toTime,
				data.text
			);
		}
		
		function resetAbsenceForm() {
			var selectedDate = getURLVariable('selectedDate');
			// Remove mask if input type date not supported
			if (Modernizr.inputtypes.date === false) {
				$ctAbsenceFormElm.find('input.ct-date-input').inputmask('remove');
			}
			$ctAbsenceFormElm.find('input.ct-input-time').inputmask('remove');
			ctAbsenceFormModel.absenceCode(null);
			ctAbsenceFormModel.fromDate(selectedDate);
			ctAbsenceFormModel.fromTime(null);
			ctAbsenceFormModel.toDate(selectedDate);
			ctAbsenceFormModel.toTime(null);
			ctAbsenceFormModel.text(null);
			$ctAbsenceFormElm.find('input.ct-input-time').inputmask({'alias': 'capitechHourAndMinutes'});
			// Add mask if input type date not supported
			if (Modernizr.inputtypes.date === false) {
				$ctAbsenceFormElm.find('input.ct-date-input').inputmask({'formatAlias':'isoDate'});
			}
		}
		
		// Model
		var absenceCode = function(properties) {
			if(typeof(properties)==='undefined')				properties					=		{};
			if(typeof(properties.absenceCode)==='undefined')	properties.absenceCode		=		'';
			if(typeof(properties.description)==='undefined')	properties.description		=		'';
			
			var self = this;
			self.absenceCode	= ko.observable(properties.absenceCode);
			self.description	= ko.observable(properties.description);
		}
		
		var absenceFormModel = function() {
			var self = this;
			self.hasAbsenceRegistrationPermissions = ko.observable(getLocalStorage("myCapitechPermissionsAndRegistrationSetup").hasAbsenceRegistration)
			self.absenceCode = ko.observable();
			self.isShortTermAbsence = ko.observable(false);
			self.fromDate = ko.observable();
			self.fromTime = ko.observable();
			self.toDate = ko.observable();
			self.toTime = ko.observable();
			self.text = ko.observable();
			self.aAbsenceCode = ko.observableArray();
			self.addAbsenceCodes = function(data) {
				// Always remove all data
				self.aAbsenceCode.removeAll();
				$.each(data, function(index, obj) {
					self.aAbsenceCode.push(new absenceCode(obj));
				});
			};
			submitAbsence = function(formElement) {
				createAbsenceRequest();
			}
		};
		
		init();
	};
}(jQuery));